import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { loginUser } from "../api"; // ✅ Importar la función corregida
import { LanguageContext } from "../context/LanguageContext"
import DemoRq from "../components/demorequest";

import WebHeaderLogin from "../components/web_header_login";

function LogIn() {

    const { t } = useContext(LanguageContext); // 👈 Usa el hook para traer traducciones

    // ✅ Definir `useState()` correctamente
    const [mail_u, setMailU] = useState("");  
    const [password_u, setPasswordU] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setError("");

        console.log("📡 Enviando datos de login:", { mail_u, password_u });  // ✅ Depuración

        try {
            const data = await loginUser(mail_u, password_u);  // ✅ Llamada API con los nombres correctos

            if (data.user) {
                localStorage.setItem("user", JSON.stringify(data.user));
                localStorage.setItem("company", JSON.stringify(data.company));
                navigate("/1.home");
            } else {
                setError(data.message || "Login failed");
            }
        } catch (err) {
            setError("Error connecting to the server");
        }
    };

    return (
        <>
        <WebHeaderLogin/>
            <div className="body">
                <h2>{t('loginT1')}</h2>
                <form onSubmit={handleLogin}>
                    <table className="table0">
                        <tbody>
                            <tr>
                                <td>{t('loginT2')}</td>
                                <td>
                                    <input
                                        className="input1" 
                                        type="text"
                                        value={mail_u}
                                        onChange={(e) => setMailU(e.target.value)}  // ✅ Funciona bien ahora
                                        required
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>{t('loginT3')}</td>
                                <td>
                                    <input
                                        className="input1" 
                                        type="password"
                                        value={password_u}
                                        onChange={(e) => setPasswordU(e.target.value)}  // ✅ Funciona bien ahora
                                        required
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    
                    <button type="submit">{t('loginT4')}</button>
                    
                </form>

                {error && <p style={{ color: "red" }}>{error}</p>}

                <section  >

                    <DemoRq/>
 
        </section>
            </div>
            
        </>
    );
}

export default LogIn;
